export const TERMS_OF_SERVICE_URL = 'https://get.pop.store/terms-of-service/';
export const PRIVACY_POLICY_URL = 'https://get.pop.store/privacy-policy/';

/** Public marketing site — where the root `/` sends a logged-out visitor. */
export const MARKETING_SITE_URL = 'https://get.pop.store';
